import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { site } from '../../data/site';
import type { ServiceChecklist, ServiceSection } from '../../types/servicePage';
type ServiceDetailsProps = {
  name: string;
  sections: ServiceSection[];
  checklist?: ServiceChecklist;
};
export function ServiceDetails({
  name,
  sections,
  checklist
}: ServiceDetailsProps) {
  return <section className="border-t border-line bg-white py-20 lg:py-24" data-id="element-362" data-mp="1wun7tuyipd2i">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-[0.75fr_1.25fr] lg:gap-16 lg:px-8" data-id="element-363" data-mp="1i2d04xf6m4y5">
        <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-364" data-mp="1mvxodxqz3kk5">
          <h2 className="font-display text-4xl font-extrabold uppercase leading-[0.95] text-ink sm:text-5xl" data-id="element-365" data-mp="1940zs3oijssi">
            About our <span className="text-brand" data-id="element-366" data-mp="1d5mfrxwcgn6x">{name.toLowerCase()}</span>
          </h2>
          <a href={site.phoneHref} className="mt-8 inline-flex items-center gap-3 rounded-lg bg-ink px-6 py-3.5 font-display text-xl font-bold text-white transition-colors duration-150 hover:bg-ink-soft" data-id="element-367" data-mp="z639zbr09nxs">
            <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-368" data-mp="1ma7k64qy0h23" /> Call {site.phone}
          </a>
        </div>

        <div data-id="element-369" data-mp="1hbcr89z9hc49">
          <div className="space-y-10" data-id="element-370" data-mp="1v8j8u18914rw">
            {sections.map(s => <article key={s.title} data-id="element-371" data-mp="1v6ovp937ygyd">
                <h3 className="font-display text-3xl font-bold leading-tight text-ink" data-id="element-372" data-mp="1q96k1axthnmo">{s.title}</h3>
                {s.body.map(p => <p key={p} className="mt-3 text-lg leading-relaxed text-ink-muted" data-id="element-373" data-mp="12knhlc1g852i">
                    {p}
                  </p>)}
              </article>)}
          </div>

          {checklist && <div className="mt-12 rounded-2xl bg-canvas p-7 sm:p-9" data-id="element-374" data-mp="17j72ra87xctt">
              <h3 className="font-display text-3xl font-bold leading-tight text-ink" data-id="element-375" data-mp="17hvy786y811n">{checklist.title}</h3>
              {checklist.intro && <p className="mt-3 text-lg leading-relaxed text-ink-muted" data-id="element-376" data-mp="eujbmy0sft8c">{checklist.intro}</p>}
              <ul className="mt-5 divide-y divide-line border-y border-line" data-id="element-377" data-mp="esoza83l19fv">
                {checklist.items.map(item => <li key={item.title} className="py-4" data-id="element-378" data-mp="2jvc76kyen5j4">
                    <p className="font-bold text-ink" data-id="element-379" data-mp="2jtss2xohj0ix">{item.title}</p>
                    {item.text && <p className="mt-0.5 text-ink-muted" data-id="element-380" data-mp="2ondtz0t78ene">{item.text}</p>}
                  </li>)}
              </ul>
            </div>}
        </div>
      </div>
    </section>;
}